import { defineChannel, type ChannelDefinition } from '../channel-definition';

// Legacy Twilio SMS. Custom SMS (`sms`) replaces it; workspaces with a Twilio
// integration or the `legacy-twilio` flag still send through it.
export const twilioChannel = defineChannel({
  id: 'twilio',
  icon: 'sms',
} as const satisfies ChannelDefinition);
